import { render, staticRenderFns } from "./ClubAnalytics.vue?vue&type=template&id=39bcaa94&scoped=true&"
import script from "./ClubAnalytics.vue?vue&type=script&lang=ts&"
export * from "./ClubAnalytics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bcaa94",
  null
  
)

export default component.exports